import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const MembershipValidation = loadable(() => import('./MembershipValidation'), {
  fallback: <LoadingScreen />,
});

export default MembershipValidation;
